// extracted by mini-css-extract-plugin
export default {"root":"DesktopGrid_root__liBMp"};